import { BaseApiError } from './base-api-error';

export class ForbiddenError extends BaseApiError {
  constructor(message = 'Forbidden') {
    super(message, 403);
    this.name = 'ForbiddenError';
  }
}
